import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import PowerIcon from '@mui/icons-material/Power';
import { useTranslation } from 'react-i18next';
import SignalStrengthIcon from '../../../shared/molecules/SignalStrengthIcon';
import { featurePropTypes } from '../../types';
import BatteryLevel from '../../../shared/molecules/BatteryLevel';
import { batteryFilter, linkqualityFilter } from '../../utils/filters';
import CustomTooltip from '../../../shared/atoms/CustomTooltip';

export const StatusSummary = ({ features, showLabels }) => {
  const { t } = useTranslation();

  const linkqualityFeature = features.find(linkqualityFilter);
  const batteryFeature = features.find(batteryFilter);
  const plugged = !batteryFeature;

  const linkqualityLabel = linkqualityFeature?.reading?.value
    ? `${linkqualityFeature.reading.value} ${linkqualityFeature.unit}`
    : '-';

  return (
    <Box
      display="flex"
      gap={1}
      sx={{
        '& *': {
          pointerEvents: 'all !important',
          cursor: 'default !important',
        },
      }}
    >
      {linkqualityFeature && (
        <>
          {showLabels && (
            <Typography
              variant="body2"
              textTransform="uppercase"
              lineHeight={1}
            >
              {linkqualityLabel}
            </Typography>
          )}

          <CustomTooltip
            title={
              showLabels ? (
                ''
              ) : (
                <Typography variant="body2" textTransform="uppercase">
                  {linkqualityLabel}
                </Typography>
              )
            }
          >
            <SignalStrengthIcon
              value={
                linkqualityFeature.reading?.value ??
                linkqualityFeature.value_max
              }
              minValue={linkqualityFeature.value_min}
              maxValue={linkqualityFeature.value_max}
              fontSize="small"
            />
          </CustomTooltip>
        </>
      )}
      {plugged ? (
        <CustomTooltip
          title={t('components.actuator_control_panel.plugged_in')}
        >
          <PowerIcon fontSize="small" />
        </CustomTooltip>
      ) : (
        <BatteryLevel
          fontSize="small"
          percentage={batteryFeature.reading?.value ?? 100}
          showLabel={showLabels}
        />
      )}
    </Box>
  );
};

StatusSummary.propTypes = {
  features: PropTypes.arrayOf(featurePropTypes),
  showLabels: PropTypes.bool,
};
